module.exports = __webpack_public_path__ + "img/terms-and-conditions.057a29a.svg";